
import React, { useState, useRef, useEffect } from "react";
import BackArrow from "../icons/BusinessHub/BackArrow";
import "../styles/EditUserDetails.css";
import BusinessHubHeader from "../components/BusinessHubHeader.js";
import SuccTickIcon from "../icons/BusinessHub/SuccTickIcon.js";
import { useNavigate, useLocation } from "react-router-dom";
import "react-datepicker/dist/react-datepicker.css";
import UserInfoInput from "./UserInfoInput.js";
import { userService } from "../services/userService.js";
import Utils from "../utils/Utils.js";
import { toast } from "react-toastify";
import companyController from "../controllers/companyController.js";
import userController from "../controllers/userController.js";
import EyeView from "../icons/SignInIcon/EyeView";
import ShowIcon from "../icons/SignInIcon/ShowIcon";

function EditUserDetails() {
  const childRef = useRef();
  const { state } = useLocation();
  const { userId, roleName } = state || {};
  const { roleID: initialRoleID } = state || {};

  const [jwt, setjwt] = useState("");
  const [roleID, setRoleID] = useState(initialRoleID || "");
  const [UserAdd, setUserAdded] = useState(false);
  const [changePasswordOpen, setChangePasswordOpen] = useState(false);
  const [newPassword, setNewPassword] = useState("");
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [passwordError, setPasswordError] = useState("");
  const [passwordLoading, setPasswordLoading] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    setjwt(userService.getUser());
  }, []);

  const openChangePassword = () => {
    setNewPassword("");
    setShowNewPassword(false);
    setPasswordError("");
    setChangePasswordOpen(true);
  };

  const closeChangePassword = () => {
    if (passwordLoading) return;
    setChangePasswordOpen(false);
  };

  const handleChangePassword = async (e) => {
    e.preventDefault();

    const passwordRulesAreValid =
      newPassword.length >= 8 &&
      /[A-Z]/.test(newPassword) &&
      /[a-z]/.test(newPassword) &&
      /\d/.test(newPassword) &&
      /[^A-Za-z0-9]/.test(newPassword);

    if (!passwordRulesAreValid) {
      setPasswordError(
        "Use at least 8 characters with uppercase, lowercase, number, and special character.",
      );
      return;
    }

    if (passwordLoading) return;

    try {
      setPasswordLoading(true);
      setPasswordError("");

      const response = await userController.changePassword({
        jwt,
        changePasswordDTO: {
          newPassword: newPassword,
          userId: userId,
        },
      });

      if (Utils.isSuccessResponse(response)) {
        toast.success("Password changed successfully");
        setChangePasswordOpen(false);
        return;
      }

      setPasswordError(
        response?.response?.data?.message ||
          response?.data?.message ||
          "Could not change the password.",
      );
    } catch (error) {
      setPasswordError(
        error?.response?.data?.message ||
          "Could not change the password. Please try again.",
      );
    } finally {
      setPasswordLoading(false);
    }
  };

  const handleSaveChange = async () => {
    const Pjwt = Utils.parseJwt(jwt);

    try {
      const userdata = await userController.getUser({
        Jwt: jwt,
        userID: userId,
      });

      if (childRef.current) {
        const addCompanyEmloyeeRequest = {
          adminID: Pjwt.id,
          birthdate: userdata.data.birthdate,
          companyID: userService.getCompID(),
          gender: {
            costumGenderName: null,
            genderName: userdata.data.gender.genderName,
            pronoun: userdata.data.gender.pronoun,
          },
          roleID: roleID,
          userID: state.userId,
          userRegister: {
            countryOfResidence: userdata.data.countryOfResidence
              ? userdata.data.countryOfResidence
              : "Lebanon",
            email: userdata.data.email,
            firstname: userdata.data.firstname,
            lastname: userdata.data.lastname,
            password: null,
            phoneNumber: userdata.data.phoneNumber,
            suffix: userdata.data.suffix,
            userType: "END_USER",
          },
        };

        const AddCompanyEmployees =
          await companyController.addCompanyEmployees({
            jwt: jwt,
            addCompanyEmloyeeRequest: addCompanyEmloyeeRequest,
          });

        if (
          AddCompanyEmployees.data &&
          Utils.isSuccessResponse(AddCompanyEmployees)
        ) {
          setUserAdded(true);
        } else if (
          !AddCompanyEmployees.data &&
          !Utils.isSuccessResponse(AddCompanyEmployees)
        ) {
          toast.error(AddCompanyEmployees.response.data.message);
        }
      }
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <div className="edit-user-screen-container">
      <div className="edit-user-page-header">
        <BusinessHubHeader />
      </div>

      <div className="edit-user-content-main-container">
        {UserAdd && (
          <div className="edit-user-popup-container">
            <div
              className="edit-user-popup-content-container"
              onClick={(e) => e.stopPropagation()}
            >
              <div className="edit-user-popup-content">
                <div className="edit-user-successfully-added-icon">
                  <SuccTickIcon />
                </div>

                <div className="edit-user-successfully-added-text">
                  User Details Updated Successfully
                </div>

                <div
                  className="edit-user-successfully-added-action-button"
                  onClick={() =>
                    navigate("/user-management", {
                      state: { active: "C" },
                    })
                  }
                >
                  Continue
                </div>
              </div>
            </div>
          </div>
        )}

        {changePasswordOpen && (
          <div
            className="edit-user-popup-container"
            onClick={closeChangePassword}
          >
            <form
              className="change-password-popup"
              onClick={(e) => e.stopPropagation()}
              onSubmit={handleChangePassword}
            >
              <div className="change-password-popup-title">Change Password</div>

              <label
                className="change-password-popup-label"
                htmlFor="edit-user-new-password"
              >
                New password <span>*</span>
              </label>
              <div className="change-password-popup-field">
                <input
                  id="edit-user-new-password"
                  className="change-password-popup-input"
                  type={showNewPassword ? "text" : "password"}
                  autoComplete="new-password"
                  autoFocus
                  value={newPassword}
                  placeholder="Enter the new password"
                  onChange={(e) => {
                    setNewPassword(e.target.value); 
                    setPasswordError("");
                  }}
                />
                <button
                  className="change-password-popup-toggle"
                  type="button"
                  onClick={() => setShowNewPassword((prev) => !prev)}
                  aria-label={
                    showNewPassword ? "Hide password" : "Show password"
                  }
                >
                  {showNewPassword ? <ShowIcon /> : <EyeView />}
                </button>
              </div>

              <div className="change-password-popup-hint">
                At least 8 characters with uppercase, lowercase, number, and
                special character.
              </div>
              {passwordError && (
                <div className="change-password-popup-error">
                  {passwordError}
                </div>
              )}

              <button
                className="change-password-popup-submit"
                type="submit"
                disabled={!newPassword || passwordLoading}
              >
                {passwordLoading ? "Saving..." : "Continue"}
              </button>
              <button
                className="change-password-popup-cancel"
                type="button"
                onClick={closeChangePassword}
              >
                Cancel
              </button>
            </form>
          </div>
        )}

        <div className="edit-user-content-container">
          <div className="edit-user-header">
            <div className="edit-user-header-navigation">
              <div
                className="edit-user-header-navigation-icon"
                onClick={() =>
                  navigate("/user-management", {
                    state: { active: "C" },
                  })
                }
              >
                <BackArrow />
              </div>

              <div className="edit-user-header-navigation-text">
                Back to User Management
              </div>
            </div>

            <div className="edit-user-header-text">
              <div className="edit-user-header-title">
                Edit User Details
              </div>

              <div className="edit-user-header-text-note">
                Update user information and role assignments
              </div>
            </div>
          </div>

          <div
            className="edit-user-change-password"
            onClick={openChangePassword}
          >
            Change Password
          </div>

          <div className="edit-user-body">
            <div className="edit-user-window-container">
              <div className="user-window-header">
                <div className="user-window-header-text-container">
                  <div className="user-window-title">
                    Personal Information
                  </div>

                  <div className="user-window-text">
                    Update the user's basic details
                  </div>
                </div>
              </div>

              <UserInfoInput
                ref={childRef}
                user={state}
                UserAdd={UserAdd}
                RoleID={roleID}
                setRoleid={setRoleID}
                setUserAdded={setUserAdded}
                mode="edit"
              />

              <div className="user-window-footer">
                <div className="user-window-footer-button-container">
                  <div
                    className="save-user-action-button"
                    onClick={handleSaveChange}
                  >
                    Save Changes
                  </div>

                  <div className="canel-action-button-container">
                    <div
                      className="cancel-user-creation-action-button"
                      onClick={() =>
                        navigate("/user-management", {
                          state: { active: "C" },
                        })
                      }
                    >
                      Cancel
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default EditUserDetails;
